<template>
  <div>
    <panel Title="محاسبه کارمزدو اقساط تسهیلات" Des="از طریق این فرم می توانید میزان کارمزد و اقساط تسهیلات رو محاسبه کنید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="container">
      <div class="row mt-3">
        <!-- <div class="col-md-4 col-12 LoanType">
          <div class="text-center font-weight-bold text-dark" style="font-size: 20px">انتخاب نوع وام</div>
          <div class="text-center mt-2">
            <small class="text-secondary">برای محاسبه تعداد اقساط و مبلغ کارمزد ، نوع تسهیلات مد نظر خود را انتخاب کنید</small>
          </div>
          <div class="mt-4">
            <div class="" v-for="(item, key) in listVam" :key="key">
              <div class="loan Pointer mt-1" @click="SelectVam(item)">{{ item.desNoe }}</div>
            </div>
          </div>
        </div> -->
        <div class="col-md-2 col-12"></div>
        <div class="col-md-8 col-12">
          <div class="text-center font-weight-bold text-dark" style="font-size: 20px">
            محاســـبه کارمزد و شرایط وام
            <!-- [ <b class="text-warning">{{ DesNoe }}</b> ] -->
          </div>
          <div v-if="NoeId != null" class="row mt-4 text-right">
            <div class="col-md-3"></div>
            <div class="col-md-6 mt-2">
              <small>مبلغ تسهیلات</small>
              <input
                type="text"
                class="form-control text-center"
                v-model="MablaghVam"
                @keypress="$ValidNumber($event, 15, false)"
                @keyup="
                  MablaghVam = $Comma3ragham(MablaghVam)
                  isCalc = false
                "
                style="font-size: 20px"
              />
              <!-- <div class="text-center mt-2 text-warning" style="font-size:15px;" v-if="MablaghVam>0">مبلغ تسهیلات {{ $Comma3ragham(MablaghVam) }}  ريال </div> -->
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-2 mt-2">
              <small>تعداد قسط</small>
              <input type="text" class="form-control text-center" maxlength="2" v-model="TedadGhest" @keyup="isCalc = false" />
            </div>
            <div class="col-md-4 mt-2">
              <small>تاریخ درخواست</small>
              <input type="text" class="form-control text-center" v-model="DateNow" disabled />
              <!-- <date-picker color="#2a3f54" v-model="DateNow" :disabled="'true'" input-class="text-center"> </date-picker> -->
            </div>
            <div class="col-md-3"></div>
            <div class="col-12 text-center mt-2">
              <button type="button" class="btn btn-success w-50" @click="calculateMablaghghest()">محاسبه مبلغ و کارمزد وام</button>
            </div>
            <div class="col-12 text-center mt-4" v-if="isCalc == true">
              <div class="h6">
                مبلغ کارمزد <span class="font-weight-bold text-dark">{{ $Comma3ragham(malaghKarmozd) }}</span> ریال
              </div>
            </div>
            <div class="col-12 text-center mt-2" v-if="isCalc == true">
              <div class="h6">
                مبلغ اقساط با احتساب کارمزد <span class="font-weight-bold text-dark">{{ $Comma3ragham(malaghGhestKarmozd) }}</span> ریال می باشد
              </div>
            </div>
            <div class="col-md-3"></div>
            <div class="col-6 text-center mt-4" v-if="isCalc == true">
              <div class="text-danger h6">نکته: اعلام این برآورد مبلغ وام ، تعداد قسط و مبلغ اقساط محاسبه شده ، به منزله ثبت تقاضای وام تلقی نمی گردد و صرفا جهت اطلاع می باشد</div>
            </div>
            <div class="col-md-3"></div>
          </div>
        </div>
        <div class="col-md-2 col-12"></div>
      </div>
      <div class="row text-center mt-3">
        <div class="col-12">
          <!-- <button type="button" class="btn-warning btn" @click="downloadItem('https://tekta.ir/wp-content/uploads/2025/01/loan.png')">دانلود فایل پیوستی راهنمای وام ها </button> -->
          <!-- <a :download="'Hellper'" title="دانلود فایل" :href="'http://tekta.ir/wp-content/uploads/2025/01/loan.png'" class="btn btn-secondary w-100" style="font-size: 15px" target=blank> <i class="fas fa-download"></i></a> -->
          <a :download="'Hellper'" title="دانلود فایل" :href="'https://tekta.ir/wp-content/uploads/2025/01/loan1404.png'" class="btn btn-warning " style="font-size: 15px" target=blank> دانلود فایل پیوستی راهنمایی محاسبات <i class="fas fa-download"></i></a>

          <!-- <img class="w-100" src="https://tekta.ir/wp-content/uploads/2025/01/loan.png"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Panel from '../Tools/NetPa/Panel.vue'

export default {
  components: { Panel },
  data() {
    return {
      listVam: [],
      DesNoe: '',
      NoeId: null,
      DateNow: this.$GetJalaliDate(),
      MablaghVam: 0,
      TedadGhest: 1,
      malaghGhest: 0,
      malaghGhestKarmozd: 0,
      malaghKarmozd: 0,
      isCalc: false,
    }
  },
  methods: {
    SelectVam(vam) {
      this.DesNoe = vam.desNoe
      this.NoeId = vam.id
      //   this.MablaghVam=this.$Comma3ragham(vam.minMablagh)
    },
    GetNoeVam() {
      var DataAxiosGetNoeVam = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVamNew/SelTozihatRequest',
        Token: this.$session.get('TokenNetPa'),
      }
      var formdata = new FormData()
      this.$PostFormData(DataAxiosGetNoeVam).then((data) => {
        this.NoeId = data[0].id
        this.listVam = data
      })
    },
    calculateMablaghghest() {
      if (this.NoeId != null) {
        var formdata = new FormData()
        formdata.append('wwwtblNoeId', this.NoeId)
        formdata.append('MabDarkhastVam', Number(this.MablaghVam.replace(/,/g, '')))
        formdata.append('TedadGhest', this.TedadGhest)
        formdata.append('TarixDarkhast', this.DateNow)
        var DataAxios = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'InsNewVam/CalcKarmozd',
          Token: this.$session.get('TokenNetPa'),
        }
        this.$PostFormData(DataAxios).then((res) => {
          this.isCalc = true
          this.malaghGhest = Number(this.MablaghVam.replace(/,/g, '')) / this.TedadGhest
          this.malaghKarmozd = res.data[0].karmozdBimeSood
          this.malaghGhestKarmozd = (res.data[0].karmozdBimeSood + Number(this.MablaghVam.replace(/,/g, ''))) / this.TedadGhest
          this.malaghGhestKarmozd = Math.round(this.malaghGhestKarmozd)
        })
      }
    },
    downloadURI(uri) {
            var fileLink = document.createElement('a')
            fileLink.download = 'File'
            fileLink.href = uri
            document.body.appendChild(fileLink)
            fileLink.target = '_blank'
            fileLink.click()
    },
    downloadItem ( url) {
      
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/png' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'Downlod'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
  }
  },
  created() {
    this.GetNoeVam()
  },
}
</script>

<style lang="scss" scoped>
.LoanType {
  // border-left: 2px dashed #242646 !important;
  // height: 70vh;
  // max-height: 70vh;
}
.loan {
  text-align: center;
  background: #2a3f54;
  border-radius: 5px;
  color: rgb(206, 206, 206);
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1rem;
  transition: 0.3s;
}
.loan:hover {
  color: #2a3f54;
  background: none;
  border: #2a3f54 dashed 2px;
  transition: 0.3s;
  font-weight: bold;
}
</style>
